import { SelectOption } from '../../logic/types'
import { Subscription } from '../../shared/types/BotUsers'
import { GroupedBotProperty } from '../BotProperties/components/Properties/types'
import {
  UserSendMessageExtraItems,
} from '../BotUsers/components/UserSendMessage/types'
import { UserProfile } from '../BotUsers/components/Users/types'
import { IChannelSubscriptionInfo } from '../ChannelSubscriptionInfo/types'
import { Notice, PayStatus } from "../Shop/Notices/types";

export type UserProfileConfig = {
  user_id: number
  getProfile: (id: number) => Promise<UserProfile>
  cardHelper: ProfileCardHelper
  tabsHelper: ProfileTabsHelper
  mediaTargetId: string | number
}

export type ProfileCardHelper = {
  ban: (id: number) => Promise<void>
  unban: (id: number) => Promise<void>
  getLabels: () => { [key: number]: string }
  createLabel: (name: string) => Promise<{ index: number }>
  addLabel: (user_id: number, label_id: number) => Promise<{ labels: { [key: number]: string }, user_id: number }>
  removeLabel: (user_id: number, label_id: number) => Promise<{ labels: { [key: number]: string }, user_id: number }>
  userSendMessage?: UserSendMessageExtraItems
  setUserAttributeInfo?:SetUserAttributeInfo
  gotoUser?: (id: number) => void
}

export type UserAttributes = UtmAttribute | ReferringUserAttribute

export enum UserAttributesEnum {
  Utm = 'Utm',
  ReferringUser = 'ReferringUser'
}

export type UtmAttribute = {
  attribute: UserAttributesEnum.Utm
  value: string | null
}

export type ReferringUserAttribute = {
  attribute: UserAttributesEnum.ReferringUser
  value: number | null
}

export type SetUserAttributeInfo = {
  setUserAttribute: (userId: number, attribute: UserAttributes) => Promise<boolean | void>
}

export type ProfileTabsHelper = {
  properties: PropertiesHelper
  notices: NoticesHelper
  subscriptions: SubscriptionsHelper
}

export type NoticesHelper = {
  getNotices: (payload: { offset: number, limit: number, pay_status?: PayStatus, customer_id?: number }) => Promise<{ items: Array<Notice>, count: number }>
  refundPayment?: (notice: Notice) => Promise<Notice | void>
}

export type PropertyValueType = string | number | boolean | Array<string>

export type PropertiesHelper = {
  setProperty: (user_id: number, property_id: number, value: PropertyValueType) => Promise<{ value: PropertyValueType }>
  removeProperty: (user_id: number, property_id: number) => Promise<{ value: string | number | boolean  }>
  getProperties: () => Array<GroupedBotProperty>
}

export type SubscriptionsHelper = IChannelSubscriptionInfo & {
  createSubscription: (user_id: number, channel_id: number, duration: number) => Promise<Subscription>
  removeSubscription: (user_id: number, channel_id: number) => Promise<void>
  getChannelTitle: (id: number) => string | undefined
  getFreeChannelsOptions: (busy: Array<number>) => Array<SelectOption>
}
